import React, { memo } from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/system'
import CopyrightFooter from '../CopyrightFooter'
export const footerHeight = '100px'

const WithFooterOutlet: React.FC = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        flexDirection: 'column'
      }}>
      <Box
        component='main'
        sx={{
          flexGrow: '1'
        }}>
        <Outlet />
      </Box>

      <CopyrightFooter />
    </Box>
  )
}

const MemoizedFooterOutlet = memo(WithFooterOutlet)

export default MemoizedFooterOutlet
